import React from 'react';
import { bool, shape, string } from 'prop-types';

const Plus = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z" fill="currentColor" />
  </svg>
);

Plus.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Plus;
